import BlockComponentImage from '../../../models/BlockComponentValues/BlockComponentImage';
import BlockComponentText from '../../../models/BlockComponentValues/BlockComponentText';
import SubBlockMenuData from './SubBlockMenuData';

class BlockMenuListWithColumnsData {
  title: BlockComponentText;
  titleImage: BlockComponentImage;
  backgroundImage: BlockComponentImage;
  menus: SubBlockMenuData[];
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace BlockMenuListWithColumnsData {
  export function make(
    title?: string,
    titleImage?: string,
    backgroundImage?: string,
    menus?: SubBlockMenuData[],
  ): BlockMenuListWithColumnsData {
    return {
      title: title ? BlockComponentText.make(title) : undefined,
      titleImage: titleImage ? BlockComponentImage.make(titleImage) : undefined,
      backgroundImage: BlockComponentImage.make(backgroundImage),
      menus,
    };
  }

  export function getDefault(title = 'タイトル', titleImage = '', backgroundImage = ''): BlockMenuListWithColumnsData {
    return make(
      `<p><strong>${title}</strong></p>`,
      titleImage,
      backgroundImage,
      [
        SubBlockMenuData.getDefault(undefined, titleImage),
        SubBlockMenuData.getDefault(undefined, titleImage),
        SubBlockMenuData.getDefault(undefined, titleImage),
        SubBlockMenuData.getDefault(undefined, titleImage),
        SubBlockMenuData.getDefault(undefined, titleImage),
        SubBlockMenuData.getDefault(undefined, titleImage),
      ],
    );
  }
}

export default BlockMenuListWithColumnsData;
